import React from "react";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import "../i18n";
import LanguageSelector from "./LanguageSelector";
import "./Form.css"; // Import your CSS file for styling
import { sendConfirmationEmail } from "./FuncUtils";
import { getToken } from "firebase/app-check";
import { appCheck } from "../services/firebase"; // ou l'endroit où tu exportes `appCheck`

export default function Form() {
  const [success, setSuccess] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [loading, setLoading] = useState(false);

  const theCode = process.env.REACT_APP_CODE;
  const theApiUrl = process.env.REACT_APP_API_URL;
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const inputRef = useRef(null);

  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  async function addUser(formData) {
    //console.log("Données à envoyer addUser:", formData);
    const appCheckToken = await getToken(appCheck, true);
    try {
      const response = await fetch(`${theApiUrl}/addUser`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "ShOgoAPI",
          "X-Firebase-AppCheck": appCheckToken.token,
        },
        body: JSON.stringify(formData),
      });

      // on lit la réponse JSON
      const xxxdata = await response.json();
      //console.log("formData :", formData);

      if (!response.ok) {
        // si la réponse HTTP n'est pas 200
        throw new Error(xxxdata.message || "Une erreur est survenue");
      }

      //console.log("Succès :", xxxdata);
      // data.id contient l'ID du doc créé si succès (selon votre API)
      return xxxdata;
    } catch (error) {
      console.error("Erreur lors de la création du user :", error);
      throw error;
    }
  }

  const onSubmit = async (data) => {
    //console.log("Form Data:", data);
    //console.log("Données à envoyer onSubmit:", data);
    setLoading(true);
    //alert(t("submit"));
    try {
      const results = await addUser(data);

      //console.log("results", results);
      await sendConfirmationEmail(
        results.id,
        data.firstname,
        data.lastname,
        data.email,
        i18n.language,
      ); //send email
      //send email

      reset({
        ...data,
        firstname: "",
        lastname: "",
        title: "",
        email: "",
        workUrl: "",
        telWork: "",
        dinnerReservation: "",
        vegetarianMeal: "",
        mailing: false,
        rgpd: false,
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
      }, 10000);
      setLoading(false);
    } catch (error) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setErrorMsg(true);
      setTimeout(() => {
        setErrorMsg(false);
      }, 10000);
      setLoading(false);
    }
  };

  const bappMember = watch("bappMember");
  const invitedBy = watch("invitedBy");

  useEffect(() => {
    inputRef.current?.focus(); // Set focus on the input field when the component mounts
  }, []);

  return (
    <>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-spinner"></div>
          {t("Envoi en cours...")}
        </div>
      )}
      <LanguageSelector />
      <h1>BAPP NETWORKING GIFT SHOW 2026</h1>
      <h2>{t("registration")}</h2>
      <h3>27.08.2026</h3>

      <div className="form-wrapper">
        <div className="form-column">
          {success && (
            <div className="alert alert-success">{t("code.success")}</div>
          )}
          {errorMsg && (
            <div className="alert alert-error">{t("code.error")}</div>
          )}

          <div className="info-box">{t("placeholders.Vetting")}</div>

          <form onSubmit={handleSubmit(onSubmit)} className="form-container">
            <div
              className="info-box"
              style={{ fontSize: "0.85rem", textAlign: "center" }}
            >
              <span className="required">*</span>{" "}
              {t("placeholders.MandatoryField")}
            </div>

            {/* Code d'accès */}
            <div className="form-section">
              <div className="form-section-title">
                🔐 {t("placeholders.registrationCode")}
              </div>
              <div className="form-field">
                <input
                  type="text"
                  placeholder={t("placeholders.registrationCode") + " *"}
                  className={errors.registrationCode ? "error" : ""}
                  {...register("registrationCode", { required: true })}
                  onBlur={() => {
                    const value = watch("registrationCode");
                    if (value.toLowerCase() !== theCode) {
                      alert(t("code.incorrect"));
                      setTimeout(() => {
                        inputRef.current?.focus();
                      }, 0);
                    }
                  }}
                />
                {errors.registrationCode && (
                  <span className="error-message">{t("errors.required")}</span>
                )}
              </div>
            </div>

            {/* Informations personnelles */}
            <div className="form-section">
              <div className="form-section-title">
                👤 {t("Personal Information") || "Informations personnelles"}
              </div>

              <div className="form-field">
                <input
                  type="text"
                  placeholder={t("placeholders.firstname") + " *"}
                  className={errors.firstname ? "error" : ""}
                  {...register("firstname", { required: true })}
                />
                {errors.firstname && (
                  <span className="error-message">{t("errors.required")}</span>
                )}
              </div>

              <div className="form-field">
                <input
                  type="text"
                  placeholder={t("placeholders.lastname") + " *"}
                  className={errors.lastname ? "error" : ""}
                  {...register("lastname", { required: true, maxLength: 100 })}
                />
                {errors.lastname && (
                  <span className="error-message">{t("errors.required")}</span>
                )}
              </div>

              <div className="form-field">
                <input
                  type="text"
                  placeholder={t("placeholders.title")}
                  className={errors.title ? "error" : ""}
                  {...register("title", { maxLength: 80 })}
                />
                {errors.title && (
                  <span className="error-message">{t("errors.required")}</span>
                )}
              </div>
            </div>

            {/* Informations professionnelles */}
            <div className="form-section">
              <div className="form-section-title">
                💼{" "}
                {t("Professional Information") ||
                  "Informations professionnelles"}
              </div>

              <div className="form-field">
                <input
                  type="text"
                  placeholder={t("placeholders.organization") + " *"}
                  className={errors.organization ? "error" : ""}
                  {...register("organization", {
                    required: true,
                    min: 1,
                    maxLength: 128,
                  })}
                />
                {errors.organization && (
                  <span className="error-message">{t("errors.required")}</span>
                )}
              </div>

              <div className="form-field">
                <input
                  type="text"
                  placeholder={t("placeholders.workUrl")}
                  {...register("workUrl")}
                />
              </div>
            </div>

            {/* Contact */}
            <div className="form-section">
              <div className="form-section-title">
                📞 {t("Contact") || "Contact"}
              </div>

              <div className="form-field">
                <input
                  type="text"
                  placeholder={t("placeholders.email") + " *"}
                  className={errors.email ? "error" : ""}
                  {...register("email", {
                    required: true,
                    pattern: /^\S+@\S+$/i,
                  })}
                />
                {errors.email && (
                  <span className="error-message">
                    {errors.email.type === "pattern"
                      ? t("errors.email")
                      : t("errors.required")}
                  </span>
                )}
              </div>

              <div className="form-field">
                <input
                  type="text"
                  placeholder={t("placeholders.telWork") + " *"}
                  className={errors.telWork ? "error" : ""}
                  {...register("telWork", { required: true, maxLength: 20 })}
                />
                {errors.telWork && (
                  <span className="error-message">{t("errors.required")}</span>
                )}
              </div>

              <div className="form-field">
                <input
                  type="tel"
                  placeholder={t("placeholders.telCell")}
                  {...register("telCell", { maxLength: 20 })}
                />
              </div>
            </div>

            {/* Adresse */}
            <div className="form-section">
              <div className="form-section-title">
                📍 {t("Address") || "Adresse"}
              </div>

              <div className="form-field">
                <input
                  type="text"
                  placeholder={t("placeholders.streetAndNumber") + " *"}
                  className={errors.streetAndNumber ? "error" : ""}
                  {...register("streetAndNumber", {
                    required: true,
                    maxLength: 127,
                  })}
                />
                {errors.streetAndNumber && (
                  <span className="error-message">{t("errors.required")}</span>
                )}
              </div>

              <div className="form-field">
                <input
                  type="text"
                  placeholder={t("placeholders.postalCode") + " *"}
                  className={errors.postalCode ? "error" : ""}
                  {...register("postalCode", { required: true, maxLength: 10 })}
                />
                {errors.postalCode && (
                  <span className="error-message">{t("errors.required")}</span>
                )}
              </div>

              <div className="form-field">
                <input
                  type="text"
                  placeholder={t("placeholders.city") + " *"}
                  className={errors.city ? "error" : ""}
                  {...register("city", { required: true })}
                />
                {errors.city && (
                  <span className="error-message">{t("errors.required")}</span>
                )}
              </div>

              <div className="form-field">
                <input
                  type="text"
                  placeholder={t("placeholders.region")}
                  {...register("region")}
                />
              </div>

              <div className="form-field">
                <input
                  type="text"
                  placeholder={t("placeholders.country") + " *"}
                  className={errors.country ? "error" : ""}
                  {...register("country", { required: true, maxLength: 29 })}
                />
                {errors.country && (
                  <span className="error-message">{t("errors.required")}</span>
                )}
              </div>
            </div>

            {/* BAPP Membership & Invitation */}
            <div className="form-section">
              <div className="form-section-title">
                🎫 {t("More Details") || "Plus de détails"}
              </div>

              <div className="form-field">
                <label>
                  {t("placeholders.bappMember")}{" "}
                  <span className="required">*</span>
                </label>
                <div className="radio-group">
                  <label className="radio-option">
                    <input
                      {...register("bappMember", { required: true })}
                      type="radio"
                      value="Yes"
                    />
                    <span>{t("placeholders.Yes")}</span>
                  </label>
                  <label className="radio-option">
                    <input
                      {...register("bappMember", { required: true })}
                      type="radio"
                      value="No"
                    />
                    <span>{t("placeholders.No")}</span>
                  </label>
                </div>
                {errors.bappMember && (
                  <span className="error-message">{t("errors.required")}</span>
                )}
              </div>

              <div className="form-field">
                {/*<label>
                  {t("placeholders.invitedBy")}{" "}
                  <span className="required">*</span>
                </label>*/}
                <select
                  {...register("invitedBy")}
                  defaultValue="hidden"
                  className={invitedBy === "" ? "error" : ""}
                  hidden
                >
                  <option value="" disabled hidden>
                    {t("Select an option") || "Sélectionnez une option"}
                  </option>

                  <option value="autre">{t("Not invited / other")}</option>

                  <optgroup label={t("The organiser")}>
                    <option value="BAPP">BAPP</option>
                  </optgroup>
                  <optgroup label={t("The exhibitors")}>
                    <option value="AD-CORNER">AD-CORNER</option>
                    <option value="AHK PROD">AHK PROD</option>
                    <option value="AKASHI">AKASHI</option>
                    <option value="ANDA">ANDA</option>
                    <option value="BALADEO">BALADEO</option>
                    <option value="BELMAR PUB">BELMAR PUB</option>
                    <option value="BIC GRAPHIC">BIC GRAPHIC</option>
                    <option value="BORACAY">BORACAY</option>
                    <option value="BOSSCHER INTERNATIONAL">
                      BOSSCHER INTERNATIONAL
                    </option>
                    <option value="BOTTLE PROMOTIONS">BOTTLE PROMOTIONS</option>
                    <option value="BRUNNEN">BRUNNEN</option>
                    <option value="CARRYON">CARRYON</option>
                    <option value="CHILI CONCEPT">CHILI CONCEPT</option>
                    <option value="CLIPPER INTERALL">CLIPPER INTERALL</option>
                    <option value="COMMERCIAL SWEETS">COMMERCIAL SWEETS</option>
                    <option value="DAIBER">DAIBER</option>
                    <option value="DELSEY">DELSEY</option>
                    <option value="EASY GIFTS">EASY GIFTS</option>
                    <option value="EMOTION FACTORY & SCHNEIDER">
                      EMOTION FACTORY & SCHNEIDER
                    </option>
                    <option value="ERGA">ERGA</option>
                    <option value="EUROPEAN SOURCING">EUROPEAN SOURCING</option>
                    <option value="FALK&ROSS">FALK&ROSS</option>
                    <option value="GIVING EUROPE">GIVING EUROPE</option>
                    <option value="GOLDSTAR">GOLDSTAR</option>
                    <option value="GOODWILL (ELASTO)">GOODWILL (ELASTO)</option>
                    <option value="HOMEIJ">HOMEIJ</option>
                    <option value="I.P.A.">I.P.A.</option>
                    <option value="IDEES NATURE">IDEES NATURE</option>
                    <option value="IMPLIVA">IMPLIVA</option>
                    <option value="INSPIRION">INSPIRION</option>
                    <option value="INTEMPOREL">INTEMPOREL</option>
                    <option value="KOZIOL">KOZIOL</option>
                    <option value="L-SHOP TEAM">L-SHOP TEAM</option>
                    <option value="MAKITO">MAKITO</option>
                    <option value="METEREX">METEREX</option>
                    <option value="MISTER LANYARD">MISTER LANYARD</option>
                    <option value="NEW WAVE">NEW WAVE</option>
                    <option value="OCTOGONE">OCTOGONE</option>
                    <option value="PACOR">PACOR</option>
                    <option value="PASSOT INNOVATION">PASSOT INNOVATION</option>
                    <option value="PF CONCEPT">PF CONCEPT</option>
                    <option value="PLASTORIA">PLASTORIA</option>
                    <option value="POUL WILLUMSEN">POUL WILLUMSEN</option>
                    <option value="PREFIX DESIGN">PREFIX DESIGN</option>
                    <option value="PREMO BV">PREMO BV</option>
                    <option value="PRODIR">PRODIR</option>
                    <option value="PROMIDATA">PROMIDATA</option>
                    <option value="PROMOTION 4U">PROMOTION 4U</option>
                    <option value="REFLECTS">REFLECTS</option>
                    <option value="SAMDAM">SAMDAM</option>
                    <option value="SCHÄFER">SCHÄFER</option>
                    <option value="SENATOR">SENATOR</option>
                    <option value="SIPLA">SIPLA</option>
                    <option value="SOLO + MIDOCEAN">SOLO + MIDOCEAN</option>
                    <option value="STANLEY & STELLA">STANLEY & STELLA</option>
                    <option value="STRICKER">STRICKER</option>
                    <option value="SWEETWARE">SWEETWARE</option>
                    <option value="TED GIFTED ">TED GIFTED </option>
                    <option value="TEXET">TEXET</option>
                    <option value="THE GIFT">THE GIFT</option>
                    <option value="THE OUTDOORS COMPANY">
                      THE OUTDOORS COMPANY
                    </option>
                    <option value="TOP TEX">TOP TEX</option>
                    <option value="TOPPOINT">TOPPOINT</option>
                    <option value="UBAG">UBAG</option>
                    <option value="UMA">UMA</option>
                    <option value="XD-CONNECTS">XD-CONNECTS</option>
                  </optgroup>
                </select>
                {invitedBy === "" && (
                  <span className="error-message">{t("errors.required")}</span>
                )}
              </div>
            </div>

            {/* Dinner Section (only for BAPP members) */}
            {bappMember === "Yes" && (
              <div className="dinner-section">
                <div className="dinner-section-title">
                  🍽️ {t("placeholders.Dinner") || "Dîner"}
                </div>
                <p
                  style={{
                    fontSize: "0.9rem",
                    marginBottom: "1rem",
                    color: "#555",
                  }}
                >
                  {t("placeholders.infoDinner")}
                </p>
                <div className="form-field">
                  <input
                    type="text"
                    placeholder={t("placeholders.dinnerReservation")}
                    {...register("dinnerReservation", { min: 0 })}
                  />
                </div>
                <p
                  style={{
                    fontSize: "0.9rem",
                    marginBottom: "0.5rem",
                    marginTop: "1rem",
                    color: "#555",
                  }}
                >
                  {t("placeholders.infoVegetarian")}
                </p>
                <div className="form-field">
                  <input
                    type="text"
                    placeholder={t("placeholders.vegetarianMeal")}
                    {...register("vegetarianMeal", { min: 0 })}
                  />
                </div>
              </div>
            )}

            {/* Preferences & GDPR */}
            <div className={`checkbox-field ${errors.mailing ? "error" : ""}`}>
              <input type="checkbox" id="mailing" {...register("mailing")} />
              <label htmlFor="mailing">{t("placeholders.mailing")}</label>
            </div>

            <div className={`checkbox-field ${errors.rgpd ? "error" : ""}`}>
              <input
                type="checkbox"
                id="rgpd"
                {...register("rgpd", { required: true })}
              />
              <label htmlFor="rgpd">
                <span className="required">*</span> {t("placeholders.rgpd")}{" "}
                <a
                  href="/rgpd"
                  target="_blank"
                  style={{ color: "#007bff", textDecoration: "underline" }}
                >
                  {t("placeholders.MoreInfo")}
                </a>
              </label>
            </div>
            {errors.rgpd && (
              <span className="error-message">{t("errors.required")}</span>
            )}

            <input
              {...register("language", { value: i18n.language })}
              type="hidden"
            />

            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? t("Envoi en cours...") : t("submit")}
            </button>
          </form>

          {success && (
            <div className="alert alert-success" style={{ marginTop: "2rem" }}>
              {t("code.success")}
            </div>
          )}
          {errorMsg && (
            <div className="alert alert-error" style={{ marginTop: "2rem" }}>
              {t("code.error")}
            </div>
          )}
        </div>
        <div className="info-column">
          <div className="info-box-location">
            <h4>{t("Adresse du jour")}</h4>
            <p>
              TOUR & TAXIS - SHED 2 <br />
              <br />
              {t("adresse")} <br />
              <br />
              {t("heure d'ouverture")} : 9:30 – 17:30
              <br />
              <br />
            </p>
            <a
              href="https://maps.app.goo.gl/shxvy9YLxJpWrhrn7"
              target="_blank"
              rel="noreferrer"
            >
              <img src={require("../assets/map.jpg")} alt="Map" />
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
// <button onClick={onSubmit2}>test </button>
